import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * @deprecated Since 2026-10-23. Use `infcLangInterceptor` from
 * `@infodata-group/inf-commons-core`.
 */
export const langInterceptor: HttpInterceptorFn = (req, next) => {
  const translateService = inject(TranslateService);
  if (req.url.indexOf('.json') > -1) {
    return next(req);
  }

  // Lang is already set up, no need to add it
  if (req.url.indexOf('LGE') > -1) {
    return next(req);
  }

  const currentLang = translateService.getCurrentLang() ?? 'fr';
  let newUrl = `${req.url}?LGE=${currentLang}`;
  if (req.url.indexOf('?') > -1) {
    newUrl = `${req.url}&LGE=${currentLang}`;
  }
  return next(
    req.clone({
      url: newUrl,
    }),
  );
};
